const getFormattedDate = (date, isDatePicker) => {
  var currentDate = new Date(date);

  var month = (currentDate.getUTCMonth() + 1).toString().padStart(2, "0");
  var day = currentDate.getUTCDate().toString().padStart(2, "0");
  var year = currentDate.getUTCFullYear().toString();

  var formattedDateTime = isDatePicker ? (`${year}-${month}-${day}`) : (month + "/" + day + "/" + year);
  return formattedDateTime;
};

export const dateTimeFormat = (date, isHyphen) => {
  const dateTime = new Date(date);
  const year = dateTime.getUTCFullYear();
  const month = String(dateTime.getUTCMonth() + 1).padStart(2, '0');
  const day = String(dateTime.getUTCDate()).padStart(2, '0');
  const hour = String(dateTime.getUTCHours()).padStart(2, '0');
  const minute = String(dateTime.getUTCMinutes()).padStart(2, '0');
  const second = String(dateTime.getUTCSeconds()).padStart(2, '0');
  
  const formattedDateTime = 
  isHyphen ? `${year}-${month}-${day} ${hour}:${minute}:${second}` :
  `${month}/${day}/${year} ${hour}:${minute}:${second}`;
  return formattedDateTime;
};

export default getFormattedDate;
